// Service to automatically show phone number modal after 30 minutes
class AutoPhoneModalService {
  constructor() {
    this.modalTimers = new Map(); // Track timers for each team
    this.isRunning = false;
    this.checkInterval = 60 * 1000; // Check every minute
    this.modalDelay = 30 * 60 * 1000; // Show modal after 30 minutes
  }

  start() {
    if (this.isRunning) {
      console.log('📱 Auto phone modal service already running');
      return;
    }

    console.log('🚀 Starting auto phone modal service...');
    this.isRunning = true;

    // Set up periodic checks
    this.intervalId = setInterval(() => {
      this.checkForModalTriggers();
    }, this.checkInterval);
  }

  stop() {
    if (!this.isRunning) {
      return;
    }

    console.log('🛑 Stopping auto phone modal service...');
    this.isRunning = false;

    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    // Clear all timers
    this.modalTimers.forEach(timer => clearTimeout(timer));
    this.modalTimers.clear();
  }

  checkForModalTriggers() {
    // This will be called by the dashboard to check if modal should be shown
    // We'll implement this in the hook
  }

  scheduleModalForTeam(teamId) {
    // Clear existing timer if any
    if (this.modalTimers.has(teamId)) {
      clearTimeout(this.modalTimers.get(teamId));
    }

    // Schedule new modal
    const timer = setTimeout(() => {
      console.log(`⏰ 30 minutes elapsed for team ${teamId}, triggering modal`);
      this.triggerModalForTeam(teamId);
      this.modalTimers.delete(teamId);
    }, this.modalDelay);

    this.modalTimers.set(teamId, timer);
    console.log(`⏰ Scheduled modal for team ${teamId} in 30 minutes`);
  }

  triggerModalForTeam(teamId) {
    // Dispatch custom event to trigger modal
    const event = new CustomEvent('showPhoneModal', {
      detail: { teamId }
    });
    window.dispatchEvent(event);
  }

  cancelModalForTeam(teamId) {
    if (this.modalTimers.has(teamId)) {
      clearTimeout(this.modalTimers.get(teamId));
      this.modalTimers.delete(teamId);
      console.log(`❌ Cancelled modal for team ${teamId}`);
    }
  }

  getStatus() {
    return {
      isRunning: this.isRunning,
      activeTimers: this.modalTimers.size,
      modalDelay: this.modalDelay
    };
  }
}

// Create singleton instance
const autoPhoneModalService = new AutoPhoneModalService();

// Start the service when module loads
autoPhoneModalService.start();

export default autoPhoneModalService;
